import apiFetch from '../apiFetch'

export default function (token, templateId, templateFieldId) {
  return apiFetch({ endPoint: `template/field/${templateFieldId}`, method: 'DELETE', token: token })
}
